import { render, staticRenderFns } from "./VideoCategory.vue?vue&type=template&id=6ff14442&scoped=true&"
import script from "./VideoCategory.vue?vue&type=script&lang=js&"
export * from "./VideoCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff14442",
  null
  
)

component.options.__file = "VideoCategory.vue"
export default component.exports